import React from 'react';
import { HandsomeSpin } from '@src/components/handsome'
import { viewType, serviveMethod } from '@src/config';
import { path as parentPath } from '../index.module';
/**
 * 描述模块namespace，应用至serviceName
 */
// export const modelName = `${parentPath}/view-registered`;
export const path = `${parentPath}/view-registered`
/** 
 * 权限描述： AuthDef => Authority Definition
*/
export const AuthDef = {
    main: {
        id: path,
        name: '页面功能注册',
        parent: parentPath,
        type: viewType.page,
        // path: path, // 不填则默认id
        serviceName: `${path}/getData`, // 不填则默认id
        method: serviveMethod.GET,
        url: '/client/menu/allTree',
        sort: 1
    },
    delete: {
        id: `${path}/delete`,
        name: '删除',
        parent: path,
        type: viewType.view,
        serviceName: `${path}/delete`, // 不填则默认id
        method: serviveMethod.DELETE,
        url: '/client/menu',
        sort: 5
    },
    add: {
        id: `${path}/add`,
        name: '增加',
        parent: path,
        type: viewType.view,
        serviceName: `${path}/add`, // 不填则默认id
        method: serviveMethod.POST,
        url: '/client/menu',
        sort: 4
    },
    edit: {
        id: `${path}/edit`,
        name: '编辑',
        parent: path,
        type: viewType.view,
        serviceName: `${path}/edit`, // 不填则默认id
        method: serviveMethod.PUT,
        url: '/client/menu',
        sort: 3
    }
}

/**
 * 描述service请求方式
 *
 * @class Service
 */
export class Service {
}

const LoadPage = React.lazy(() => import(/* webpackChunkName:"view-registered" */ './index.jsx'));
/**
 * 描述代码分割后页面组件
 *
 * @export function 表示页面入口组件
 * @returns React element
 */
export default function Page () {
    return (
    // Displays <Spinner> until OtherComponent loads
    <React.Suspense fallback={<HandsomeSpin />}> 
        <LoadPage />
    </React.Suspense>
  );
}